import React from "react";
import {
  getAshButtonState,
  getAshMessage,
  getAshStatus,
  I9ButtonState,
  I9Type,
  MessageYouMustCompleteSection1,
} from "./i9-data";
import { Spinner, SpinnerSize } from "@amzn/stencil-react-components/spinner";
import { ErrorCode, getErrorMessage } from "./i9-error-message";
import { I9Legacy } from "./i9-legacy";
import { I9Caas } from "./i9-caas";
import { Tag } from "@amzn/stencil-react-components/tag";
import { Row } from "@amzn/stencil-react-components/layout";

export interface I9Response {
  isRemote?: boolean;
  errorCode?: string;
  secureURL?: string;
  allowRetry?: boolean;
  status?: string;
}

interface I9ControlledProps {
  showStatus?: boolean;
  loading?: boolean;
  i9Response?: I9Response;
  i9ErrorCode?: ErrorCode;
  onRetry: () => void;
  onSubmit: () => void;
}

export const I9Controlled = ({
  showStatus,
  loading,
  i9Response,
  i9ErrorCode,
  onRetry,
  onSubmit,
}: I9ControlledProps) => {
  if (loading || !i9Response) {
    return (
      <Spinner
        size={SpinnerSize.Small}
        loadingText="Loading I-9 status..."
        showText={true}
      ></Spinner>
    );
  }

  if (i9ErrorCode === ErrorCode.E422) {
    if (i9Response.secureURL) {
      return (
        <I9Caas
          message={MessageYouMustCompleteSection1}
          buttonState={I9ButtonState.Active}
          secureURL={i9Response.secureURL}
          onRetry={onRetry}
          onSubmit={onSubmit}
        />
      );
    }

    if (
      [
        "Section2Complete",
        "PendingSection3",
        "Section3Complete",
        "Archived",
      ].includes(i9Response?.status || "") === false
    ) {
      return <I9Legacy onLinkClick={onSubmit} />;
    } else {
      i9ErrorCode = undefined;
    }
  }

  const errorMessage = getErrorMessage(i9ErrorCode);
  const i9Type = i9Response.isRemote === true ? I9Type.Remote : I9Type.Normal;
  const i9Status = i9Response.status;
  const message = i9Status && getAshMessage(i9Type, i9Status);
  const buttonState =
    i9Status !== undefined ? getAshButtonState(i9Type, i9Status) : undefined;
  const allowRetry =
    i9Response.allowRetry || i9ErrorCode === ErrorCode.Internal;
  const ashStatus = i9Status && getAshStatus(i9Type, i9Status);

  return (
    <>
      {showStatus && ashStatus && (
        <Row margin="0 0 1rem 0">
          <Tag>{ashStatus}</Tag>
        </Row>
      )}
      <I9Caas
        errorMessage={errorMessage}
        message={message}
        buttonState={buttonState}
        secureURL={i9Response.secureURL}
        allowRetry={allowRetry}
        onRetry={onRetry}
        onSubmit={onSubmit}
      />
    </>
  );
};
